var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgNotContacted = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 338.954l-28.268-28.268-71.96 71.96-71.96-71.96-28.269 28.268 71.96 71.96-71.96 71.96 28.269 28.268 71.96-71.96 71.96 71.96L512 482.874l-71.96-71.96zM255.858.142C174.296.142 107.94 66.498 107.94 148.06c0 50.52 25.465 95.198 64.226 121.894-36.19 12.488-69.36 33.118-97.227 60.984C26.614 379.265 0 443.516 0 511.858h39.978c0-119.037 96.843-215.88 215.88-215.88 81.562 0 147.918-66.355 147.918-147.918C403.776 66.498 337.42.142 255.858.142zm0 255.858c-59.518 0-107.94-48.421-107.94-107.94S196.34 40.12 255.858 40.12s107.94 48.421 107.94 107.94S315.376 256 255.858 256z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNotContacted, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/notContacted.cfcf0231.svg";
export { ForwardRef as ReactComponent };